import Cookies from "js-cookie";

/** 封裝 js-cookie 的 Cookie 操作類別，值以 JSON 序列化存取，支援設定效期與批次移除 */
export class Cookie<S extends string, T = any> {
  public setItem = (key: S, value: T): void => {
    const convertValue = JSON.stringify(value);
    Cookies.set(key, convertValue);
  };

  public setExpireItem = (key: S, value: T, expireTime: number | Date): void => {
    const convertValue = JSON.stringify(value);
    Cookies.set(key, convertValue, { expires: expireTime });
  };

  public getItem = (key: S): any => {
    const value = Cookies.get(key);
    if (value && JSON.stringify(value) !== "{}") {
      return JSON.parse(value);
    }
    return null;
  };

  public getAllItem = (): { [key: string]: string } => {
    const value = Cookies.get();
    if (value && JSON.stringify(value) !== "{}") {
      const object: { [key: string]: string } = {};
      Object.keys(value).forEach((key: string) => {
        object[key] = JSON.parse(value[key]);
      });
      return object;
    }
    return value;
  };

  public removeItem = (key: S): void => {
    Cookies.remove(key);
  };

  public removeAll = (): void => {
    Object.keys(Cookies.get()).forEach((cookieName) => {
      Cookies.remove(cookieName);
    });
  };
}

const cookieInstance = new Cookie();
/** 預先建立好的 Cookie 共用實例，供直接存取瀏覽器 cookie */
export default cookieInstance;
